module.exports = __webpack_public_path__ + "front/img/3.93b69e88.png";